<template>
  <div class="product-info" v-loading="loading" v-if="show">
    <div class="product-info-content flex-start">
      <div class="product-info-left">
        <vue-photo-zoom-pro :out-zoomer="true">
          <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop" @slideChange="onSlideChange()"
            @mouseenter.native="mouseEnter" @mouseleave.native="mouseLeave">
            <swiper-slide v-for="(item, index) in imgList ? imgList : productImgs" :key="index">
              <!-- <img :src="item" alt="" /> -->
              <img-preview :url="item" />
            </swiper-slide>
          </swiper>
          <template slot="zoomer">
            <img-zoomer :url="imgList ? imgList[curIndex] : productImgs[curIndex]"></img-zoomer>
          </template>
        </vue-photo-zoom-pro>
        <swiper class="swiper gallery-thumbs" :options="swiperOptionTop.thumbs.swiper" ref="swiperThumbs">
          <swiper-slide v-for="(item, index) in imgList ? imgList : productImgs" :key="index"
            @click.native="change(index)" :class="index == curIndex ? 'active' : ''">
            <img :src="item" alt="" />
          </swiper-slide>
        </swiper>
      </div>
      <div class="product-info-right">
        <h1 class="product-info-right-title">
          {{ obj.name }}
        </h1>
        <div class="product-info-right-info">
          <div class="product-info-right-info-top flex-between">
            <div class="product-info-right-info-price flex-start">
              <h2>{{ $t("message.home.retailPrice" /**零售价 */) }}</h2>
              <span class="price">${{
                numberFormatFn(
                  this.price ?? obj.discountPrice ?? obj.sellingPrice
                )
              }}</span>
            </div>
            <div class="product-info-right-info-price del flex-start" v-if="![null, undefined].includes(obj.price)">
              <h2>{{ $t("message.home.originPrice" /** 原价*/) }}</h2>
              <span class="price">${{ numberFormatFn(this.skuPrice ?? obj.sellingPrice) }}</span>
            </div>
            <div class="product-info-right-info-tool flex-start">
              <div class="product-info-right-info-tool-item flex-start" @click="showServiceDialog">
                <i class="el-icon-service" style="color: var(--color-main); font-size: 20px"></i>
                <span v-if="itemname == 'FamilyMart'">{{ $t("message.home.联系商家") }}</span>
                <span v-else>{{ $t("message.home.service" /**客服 */) }}</span>
              </div>
              <div class="product-info-right-info-tool-item flex-start" @click="collectEvent">
                <!-- <img :src="require('@/assets/image/Star.png')" alt="Star" /> -->
                <i class="el-icon-star-on" />
                <!-- <i  class="el-icon-star-off" /> -->
                <span>{{ $t("message.home.collect" /**收藏 */) }}</span>
              </div>
            </div>
          </div>

          <div class="product-info-right-info-des">
            <div class="product-info-right-info-des-item flex-start">
              <div>
                <span style="margin-right: 5px">{{
                  $t("message.home.sold" /**销售量 */)
                  }}</span>
                <span>{{ numberFormatA(obj.soldNum) }}</span>
              </div>
              <!-- <div>
                <span style="margin-right: 5px">{{
                  $t("message.home.pageviews" /**浏览量 */)
                  }}</span>
                <span>{{ numberFormatA(obj.viewsNum) }}</span>
              </div> -->
            </div>
            <div class="product-info-right-info-des-item flex-start">
              <span class="label-title">
                {{ $t("message.home.goodsShip") }}
              </span>
              <span>{{ $t("message.home.goodsShipTips") }}</span>
            </div>
            <div class="product-info-right-info-des-item flex-start">
              <span class="label-title">
                {{ $t("message.home.goodsFreight") }}
              </span>
              <div class="freight-tips">
                <p>
                  {{
                    Number(obj.freightAmount) === 0
                      ? $t("message.home.goodsFreeShipping")
                      : `$${numberFormatFn(obj.freightAmount ?? 0)}`
                  }}
                </p>
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">
                    <p style="line-height: 18px">
                      {{ $t("message.home.goodsFreightTips1") }}
                    </p>
                    <p style="line-height: 18px">
                      {{ $t("message.home.goodsFreightTips2") }}
                    </p>
                    <p style="line-height: 18px">
                      {{ $t("message.home.goodsFreightTips3") }}
                    </p>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="product-info-right-info-des-item flex-start">
              <span class="label-title">
                {{ $t("message.home.quantity" /**數量 */) }}
              </span>
              <el-input-number key="1" @blur="inputNumBlur" v-model="num" min="1" :max="maxNum" />
            </div>
            <div v-if="obj.canSelectAttributes">
              <div class="product-info-right-info-des-item flex-start product-attr" v-for="(item, i) in obj.canSelectAttributes
                .goodAttrs" :key="item.attrId">
                <span class="label-title sku-titile">
                  {{ currentSkuTitle[i] }}
                </span>

                <div v-if="item.attrValues[0].icon" class="attr-container">
                  <div v-for="(attrItem, index) in item.attrValues" :key="attrItem.attrValueId"
                    @click="!attrItem.disabled && changeColor(index, attrItem)" :class="[
                      'attr-item',
                      currentIndex == index && 'active',
                      attrItem.disabled && 'disabled',
                    ]">
                    <div class="attr-img" @click="
                      !attrItem.disabled && changeGoodAttr(item.attrId, attrItem.attrValueId, i)
                      ">
                      <img :src="attrItem.iconImg" alt="" />
                    </div>
                  </div>
                </div>
                <el-select @change="(v) => changeGoodAttr(item.attrId, v)" :value="goodsAttrObj[item.attrId]"
                  :placeholder="`${$t('message.home.Opt')}${item.attrName}`" v-else>
                  <el-option :value="attrItem.attrValueId" :label="attrItem.attrValueName"
                    v-for="attrItem in item.attrValues" :key="attrItem.attrValueId" :disabled="attrItem.disabled">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="product-info-right-info-des-item flex-start">
              <span class="label-title">
                {{ $t("message.home.totalPrice" /**总价 */) }}
              </span>
              <p>
                <span class="price">${{ totalPrice }}</span>
                <!-- <span class="del-line">Total Price: $56.12</span> -->
              </p>
            </div>
          </div>
          <div class="product-info-right-info-buy">
            <el-button type="primary" @click="buy" :disabled='isIntDis'>
              {{ $t("message.home.buyNow" /**立即购买 */) }}
            </el-button>
            <div :class="['addcart', 'flex-start', isIntDis && 'disBtn']" @click="addCard">
              <span>
                {{ $t("message.home.addCart" /** 添加购物车*/) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EsOnlineServiceView v-model="showOnlieService" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BIZ_TOKEN } from "@/common";
import { notLogin } from "@/common/pageHook";
import { numberFormat, openChatPage, numberFormatA } from "@/util";
import Bus from "@/util/bus";
import vuePhotoZoomPro from "vue-photo-zoom-pro";
import { ImgZoomer, ImgPreview } from "vue-photo-zoom-pro";
import "vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css";


import {
  recommend
} from "@/api/goods/goods.js"
import {
  goods_review_list
} from "@/api/goods/review.js"
import {
  goods_consultation_list
} from "@/api/goods/consultation.js"
import {
  marketing_goods
} from "@/api/marketing/marketing.js"
import {
  hits,
  detail,
  compare_bar,
  add_compare,
  list_by_category,
  search,
} from "@/api/goods/goods.js"
import {
  get_current,
  add,
  list,
  modify,
  remove,
  clear,
} from "@/api/order/cart.js"

import {
  getCoupon
} from "@/api/marketing/coupon_code.js"

import {
  show_store_center
} from '@/api/upms/profile.js'
import {
  add as add_favorite
} from "@/api/upms/goods_favorite.js"



export default {
  name: "EsProductionInfo",
  props: {
    id: {
      type: String,
      default: "0",
    },
  },
  components: {
    vuePhotoZoomPro,
    ImgZoomer,
    ImgPreview,
  },
  data() {
    return {
      itemname: process.env.VUE_APP_ITEM_NAME,
      currentIndex: 0,
      swiperOptionTop: {
        // loop: false,
        // loopedSlides: 3, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        spaceBetween: 10,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: {
            el: ".gallery-thumbs", //定义关联的thumbs的class
            spaceBetween: 10,
            slidesPerView: "auto",
            slideToClickedSlide: true,
            watchSlidesVisibility: true,
          },
          slideThumbActiveClass: "slide-thumb-active",
        },
      },
      num: 1,
      minbuy: 1,
      goodsAttrObj: {},
      showOnlieService: false,
      loading: false,
      isCollect: false,
      canSelectAttributes: [],
      price: null,
      curIndex: 0,
      currentSkuTitle: [],
      imgList: "",
      skuPrice: null,
      maxNum: 100,
      isIntDis: true,
      show: true,
      min: 1,
      // skuSellingPrice:0




      /////////////////////////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      objsList: [],
      sizeTabsOn: 0,
      address: [],
      sizeTabs: [{
        name: 'S'
      }, {
        name: 'M'
      }, {
        name: 'L'
      }],
      // goodsId: "",
      cartSize: 0,
      imgUrls: [],
      // indicatorDots: true,
      // autoplay: true,
      // interval: 5000,
      // duration: 1000,
      circular: true,
      goodsData: [],
      proCat: [],
      thatCount: 0,
      page: 2,
      index: 2,
      brand: [],
      // 滑动
      imgUrl: [],
      kbs: [],
      lastcat: [],
      course: [],
      datas: [],
      //--
      background: ['demo-text-1', 'demo-text-2', 'demo-text-3'],
      indicatorDots: true,
      vertical: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      youhuishow: false,
      guigeshow: false,
      dizhishow: false,
      webPath: "",
      doc_doc: "",
      loadType: "load",
      formData: {
        skuId: null,
        marketingId: null,
        quantity: 1,
        currentCartId: ''
      },
      queryParams: {
        pageNumber: 0,
      },
      goodsId: '',
      skuId: '',
      obj: {},
      idxs: [],
      skuSelectedTab: '',
      skus: [],
      sku: {},
      cartQuantity: 0,
      // currentCart: {},
      marketings: [],
      coupons: [],
      store: {},
      goodsLabels: [],
      reviews: [],
      recommendGoodss: [],
      marketingModeId: null,
      seckillable: false,
      marketingId: null,
      marketingVo: null,
      showStoreCenter: false,
      notJoinGroup: false,
      nowHours: null,
      nowMinutes: null,
      nowSeconds: null,
      hours: 0, //时
      minutes: 59, //分
      seconds: 59, //秒
      countdown: '00:59:59', //倒计时
      timer: null, //重复执行

      /////////////////////////////////////////////////////////////////////////////////
    };
  },
  computed: {

    ...mapGetters(["currentCart"]),
    ...mapGetters({ islogin: "isLogin" }),

    // ...mapGetters("productDetails", [
    //   "productDetails",
    // "productComment",
    // "productCommentPageInfo",
    // "productCommentNum",
    // ]),

    // ...mapGetters({
    // productDetails: "productDetails/productDetails",
    // }),
    // ...mapGetters(["isLogin"]),

    // ...mapGetters({
    //   productDetails: "productDetails/productDetails",
    // }),
    // ...mapGetters(["isLogin"]),
    // totalPrice() {
    //   if (this.price) {
    //     return this.$big(this.num).times(this.price);
    //   } else {
    //     return 
    //     numberFormat(
    //       this.$big(this.num).times(
    //         this.productDetails.discountPrice ??
    //           this.productDetails.sellingPrice ??
    //           0
    //       )
    //     );
    //   }
    // },
    ...mapGetters({
      userInfo: "userInfo",
      isLogin: "isLogin",
    }),
    productImgs() {
      return null;
      // return new Array(10)
      //   .fill("")
      //   .map((_, index) => this.productDetails[`imgUrl${index + 1}`])
      //   .filter((item) => !!item);
    }




  },
  // watch: {
  //   productDetails: {
  //     handler(newValue, oldValue) {
  //       this.minbuy = newValue.minbuy ?? '1'
  //       if (newValue.canSelectAttributes) {
  //        if (newValue.canSelectAttributes?.goodAttrs.length){
  //          newValue.canSelectAttributes?.goodAttrs.forEach((x) => {
  //           this.goodsAttrObj[x.attrId] = x.attrValues[0].attrValueId;
  //         });
  //         this.getAttrNameAndSkuId();
  //        }
  //       }else{
  //         this.isIntDis = false
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },

  async mounted() {



    // const currentRouter = this.$router.currentRoute;
    // this.id = currentRouter.query.id;
    // if (!this.id) {
    //   // this.$router.replace("/");
    //   return;
    // }
    // try {
    //   this.loading = true;
    //   await this.requestProductDetails({
    //     sellerGoodsId: this.id,
    //   });
    // } finally {
    //   this.loading = false;
    //   localStorage.setItem("sellerId", this.productDetails.seller.id);
    //   localStorage.setItem("sellerRecId", this.productDetails.seller.id);
    //   if (this.isLogin) {
    //     this.$refs.recChild.getLike();
    //     this.$refs.likeChild.getLike();
    //   }
    //   if (!this.productDetails.id) {
    //     // this.$message({
    //     //   message: this.$t("message.home.switchLang"),
    //     // });
    //     // this.$router.replace("/");
    //   }
    // }

    const currentRouter = this.$router.currentRoute;
    this.goodsId = currentRouter.query.id;
    this.goods_detail();
    this.goods_recommend(); //推荐
    if (this.marketingId) {
      this.goods_marketing_goods();
    }
    this.formData.currentCartId = this.$store.state.currentCart ? this.$store.state.currentCart.id : null;
    this.load_show_store_center();
    this.seckillInit();

  },
  beforeDestroy() {
    localStorage.setItem(
      "seller_cache",
      JSON.stringify({
        id: this.store.id,
        name: this.store.name,
      })
    );
    this.updateProductDetails({ seller: {} });
  },
  methods: {
    numberFormatA,
    async info() {
      await this.requestProductDetails({
        sellerGoodsId: this.id,
        token: localStorage.getItem(BIZ_TOKEN),
      });
    },
    mouseEnter() {
      this.$refs.swiperTop.$swiper.autoplay.stop();
    },
    mouseLeave() {
      this.$refs.swiperTop.$swiper.autoplay.start();
    },
    changeColor(index, info) {
      this.currentIndex = index;
    },
    numberFormatFn(num) {
      return numberFormat(num);
    },

    inputNumBlur() {
      // this.num = 1;
      let maxCount = localStorage.getItem('maxBuy')
      var pattern = /^[1-9][0-9]*$/;
      if (!pattern.test(this.num)) {
        // input 框绑定的内容为空
        this.num = "1";
      } else {
        if (this.num == undefined) {
          this.num = "1";
        }
        if (this.num > maxCount) {
          this.num = maxCount;
        }
      }
    },

    ...mapActions({
      // requestProductDetails: "productDetails/requestProductDetails",
      requestCollectGoods: "user/requestCollectGoods",
      requestCollectGoodsDel: "user/requestCollectGoodsDel",
    }),
    // ...mapMutations({
    //   updateCheckProductPay: "cart/updateCheckProductPay",
    //   updateProductDetails: "productDetails/updateProductDetails",
    // }),
    onSlideChange() {
      this.curIndex = this.$refs.swiperTop.$swiper.activeIndex;
    },
    change(index) {
      this.$refs.swiperTop.$swiper.slideTo(index);
      this.curIndex = index;
    },

    changeGoodAttr(attrId, valueId, index, bool) {
      const obj = { ...this.goodsAttrObj };
      obj[attrId] = valueId;
      this.goodsAttrObj = obj;
      const disAttr = new Set();
      const allGood = this.obj?.canSelectAttributes?.goodAttrs;
      const temparr = JSON.parse(JSON.stringify(this.goodsAttrObj));

      if (allGood.length === Object.keys(this.goodsAttrObj).length) {
        allGood.forEach((item, i) => {
          if (i != index) {
            item.attrValues.forEach((attr, j) => {
              temparr[item.attrId] = attr.attrValueId;
              const { skuId } = this.getAttrNameAndSkuId(true, temparr);
              if (skuId == -1) {
                disAttr.add(attr.attrValueId);
              }
            });
          }
        });
      }
      this.obj?.canSelectAttributes?.goodAttrs.forEach((item) => {
        item.attrValues.forEach((attr) => {
          attr.disabled = disAttr.has(attr.attrValueId);
        });
      });
      this.getAttrNameAndSkuId();
      !bool && this.changeGoodAttr(attrId, valueId, index, true)
    },
    getAttrNameAndSkuId(find, obj) {
      const { skus } = this.obj.canSelectAttributes ?? {};
      if (obj && "undefined" in obj) {
        delete obj[undefined];
      }
      const attrIds = find ? Object.keys(obj) : Object.keys(this.goodsAttrObj);
      const finde = find ? obj : this.goodsAttrObj;
      const sku = skus?.find((x) => {
        let length = 0;
        if (x.attrs && x.attrs.length > 0) {
          x.attrs.forEach((attr) => {
            if (
              attrIds.includes(attr.attrId) &&
              attr.attrValueId == finde[attr.attrId]
            ) {
              length += 1;
            }
          });
        }

        return length == attrIds.length;
      }) || { skuId: -1 };
      let checkAttrName = "";

      const attrs = this.obj.canSelectAttributes?.goodAttrs;
      if (attrIds.length > 0) {
        attrIds.forEach((attrId) => {
          const a = attrs.find((attr) => attr.attrId == attrId);
          const { attrValueName } = a.attrValues.find(
            (value) => value.attrValueId === this.goodsAttrObj[attrId]
          );
          checkAttrName += `${a.attrName} : ${attrValueName}   `;
        });
      }
      this.currentSkuTitle = checkAttrName.split("  ");
      this.price = sku.discountPrice || sku.sellingPrice || this.obj.price;
      this.skuPrice = sku.sellingPrice;
      this.imgList = sku?.img;
      this.isIntDis = sku.skuId == -1;
      return {
        checkAttrName,
        img: sku.img,
        skuId: sku.attrs?.length == 0 ? '-1' : sku.skuId,
        price: this.price
      };
    },

    buy() {
      //未登录
      if (!this.isLogin) {
        this.$router.push("/login");
        this.$emit("handleBuy");
        return;
      }
      const isShelf = this.obj.isShelf;
      if (!isShelf) {
        this.$message({
          type: "warning",
          message: this.$t("message.home.productAvailable"),
        });
        return;
      }
      const { skuId, checkAttrName, price } = this.getAttrNameAndSkuId();
      const attrs = this.obj.canSelectAttributes?.skus;
      const a = attrs?.find((attr) => attr.skuId == skuId);
      const zoomImg = a?.coverImg;
      this.updateCheckProductPay([
        {
          title: this.obj.name,
          checkList: [new Date().getTime()],
          checkAll: true,
          isIndeterminate: false,
          list: [
            {
              ...this.obj,
              checkTotal: this.num,
              skuid: skuId,
              checkAttrName,
              price,
              Identifier: new Date().getTime(),
              zoomImg: zoomImg ? zoomImg : "",
            },
          ],
        },
      ]);
      this.$router.push("/settlement");
      this.$emit("handleBuy");
    },
    addCard() {
      if (this.isIntDis) {
        return;
      }
      if (notLogin()) {
        return;
      }
      const isShelf = this.obj.isShelf;
      if (!isShelf) {
        this.$message({
          type: "warning",
          message: this.$t("message.home.productAvailable"),
        });
        return;
      }

      const cartItems = this.$store.state.cartItems;
      const { skuId, checkAttrName, price } = this.getAttrNameAndSkuId();
      const attrs = this.obj.canSelectAttributes?.skus;
      const a = attrs?.find((attr) => attr.skuId == skuId);
      const zoomImg = a?.coverImg;
      const count = this.num;
      const sellerName = this.obj.seller.name;
      let str1 = cartItems.some((item) => {
        if (skuId !== -1) {
          return item.skuid == skuId;
        } else {
          return item.id == this.obj.id;
        }

      });
      this.isIntDis = false
      let isSellerName = cartItems.filter((item) => item.seller.name == sellerName)


      if (str1 && isSellerName.length) {
        this.$message({
          message: this.$t(
            "message.home.addCartMessageFaild" /**添加到购物车成功 */
          ),
          type: "warning",
        });
      } else {
        cartItems.push({
          ...this.obj,
          skuid: skuId,
          checkAttrName,
          zoomImg: zoomImg ? zoomImg : "",
          count,
          price,
          Identifier: new Date().getTime(),
        });
        this.$store.commit("cart/updateCartItems", cartItems);
        this.$message({
          message: this.$t(
            "message.home.addCartMessage" /**添加到购物车成功 */
          ),
          type: "success",
        });
      }
    },
    async collectEvent() {
      if (notLogin()) {
        return;
      }
      try {
        if (this.obj.isKeep === 1) {
          await this.requestCollectGoodsDel({
            sellerGoodsId: this.obj.id,
            token: localStorage.getItem(BIZ_TOKEN),
          });
          this.$message.warning(this.$t("message.home.cancelSuccess"));
          Bus.$emit("updateCollect", this.obj.id);
        } else {
          await this.requestCollectGoods({
            sellerGoodsId: this.obj.id,
            token: localStorage.getItem(BIZ_TOKEN),
          });
          this.$message.success(this.$t("message.home.collectionSuccess"));
          Bus.$emit("updateUnKeep", this.obj.id);
        }

        await this.requestProductDetails({
          sellerGoodsId: this.id,
          token: localStorage.getItem(BIZ_TOKEN),
        });
      } catch (err) { }
    },
    showServiceDialog() {
      if (notLogin()) {
        return;
      }
      const sellerId = this.store.id;
      const name = this.store.name;
      // openChatPage(
      //   this.$store.state.token,
      //   sellerId,
      //   name,
      //   this.productDetails.id
      // );
      // const prefix = config.HOST_URL + "/chat/#/pc/yellow?";
      // const suffix = `token=${
      //   this.$store.state.token
      // }&partyid=${sellerId}&name=${name}&productId=${
      //   this.productDetails.id
      // }&lang=${getCurrentLang().lang}`;

      // window.open(prefix + suffix, "_blank");

      // if (!notLogin()) {
      //   this.showOnlieService = true;
      // }

      // openChatPage(localStorage.getItem('BIZ_TOKEN'), this.productDetails.seller.id, this.productDetails.seller.name)
    },








    /////////////////////////////////////////////////////////////////////////////////////////////////////

    load_show_store_center() {
      show_store_center().then(response => {
        this.showStoreCenter = response.data.data.showStoreCenter;
      })
    },
    goods_detail() {
      this.loading=true;
      detail({
        "goodsId": this.goodsId,
        "skuId": this.skuId
      }).then(response => {
        let data = response.data;
        this.loading=false;
        this.obj = data.data.goods;
        this.store = data.data.store;
        this.skus = data.data.skus;
        this.reviews = data.data.reviews;
        this.goodsLabels = data.data.goodsLabels;
        this.marketings = data.data.marketings;
        this.coupons = data.data.coupons;
        if (0 <= this.obj.specificationItems && 1 == this.skus.length) {
          this.formData.skuId = this.skus[0].id;
        }
        this.defaultSkuSelect();
      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    //秒杀初始化
    seckillInit() {
      let now = new Date();
      let nowHour = now.getHours();
      this.minutes = 59 - now.getMinutes();
      this.seconds = 60 - now.getSeconds();
      this.timer = setInterval(() => {
        this.timeCount()
      }, 1000);
    },
    // 倒计时
    timeCount() {
      --this.seconds;
      if (this.seconds <= 0) {
        --this.minutes;
        this.seconds = 59;
      }
      if (this.minutes <= 0) {
        --this.hours;
        this.minutes = 59
      }
      if (this.hours < 0) {
        this.hours = 0;
        this.seconds = 59;
        this.minutes = 59;
      }
      this.countdown = this.hours + ":" + this.minutes + ":" + this.seconds;
    },
    goods_favorite_add() {
      if (this.isLogin) {
        add_favorite({
          "goodsId": this.obj.id
        }).then(response => {
          let statusCode = response.status;
          if (200 == statusCode) {
            this.$message({
              message: this.$t("message.home.collectionSuccess"),
              type: "success",
            });
          }
        }).catch(error => {
          let errResponse = JSON.parse(error.request.response ? error.request.response : '');
          if (errResponse && errResponse.message) {
            if (errResponse.message == 'shop_goodsFavorite_exist') {
              this.$message({
                message: '商品已被收藏',
                type: "success",
              });
            }
          }
        })
      } else {
        this.$message({
          message: this.$t("message.home.notLogin"),
          type: "warning",
        });
        this.$router.push("/login");
      }

    },
    goods_marketing_goods() {
      this.loading=true;
      marketing_goods({
        "goodsId": this.id,
        "marketingId": this.marketingId
      }).then(response => {
        this.loading=false;
        this.marketingVo = response.data.data;

      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_recommend() {
      this.loading=true;
      recommend({
        "rankingType": "SCORE_COUNT",
        "storeId": this.store.id,
        "count": 5
      }).then(response => {
        this.loading=false;
        this.recommendGoodss = response.data.data.recommendGoodss;

      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_get_coupon(index, id, code) {
      if (code) {
        return;
      }
      this.loading=true;
      getCoupon({
        'id': id
      }).then(response => {
        this.loading=false;
        let status = response.data.message;
        if (status == 'SUCCESS') {
          this.coupons[index].code = response.data.data.couponCode.code ? response.data.data
            .couponCode.code : null;
          // uni.showToast({
          // 	title: '领取成功',
          // 	duration: 2000
          // });
        }
        if (status == 'FILD') {
          // uni.showToast({
          // 	title: '已领完,领取失败！',
          // 	duration: 2000
          // });
        }
      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_review_list() {
      this.loading=true;
      goods_review_list({
        'id': this.addressId
      }).then(response => {
        this.loading=false;
        this.formData = response.data.data.address;

      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    goods_consultation_list() {
      this.loading=true;
      goods_consultation_list({
        'id': this.addressId
      }).then(response => {
        this.loading=false;
        this.formData = response.data.data.address;

      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    //默认sku选中
    defaultSkuSelect: function () {
      for (let i = 0; i < this.skus.length; i++) {
        if (this.skus[i].isDefault) {
          this.sku = this.skus[i];
          this.formData.skuId = this.sku.id;
        }
      }

      for (let i = 0; i < this.obj.specificationItems.length; i++) {
        let entries = this.obj.specificationItems[i].entries;
        for (let x = 0; x < entries.length; x++) {

          if (this.sku.specificationValues[i].value == entries[x].value) {
            this.idxs[i] = x
            // this.$set(this.idxs, i, x);
          }
        }
      }
      this.goods_marketing_goods();
    },
    //颜色
    skuShowTab: function (index, idx, item) {
      // this.idxs[index]=idx
      this.$set(this.idxs, index, idx);
      this.skuSelectedTab = '';
      let selectedSpecItems = [];
      for (let i = 0; i < this.obj.specificationItems.length; i++) {
        let entries = this.obj.specificationItems[i].entries;
        for (let x = 0; x < entries.length; x++) {
          if (this.idxs[i] == x) {
            this.skuSelectedTab += entries[x].value + "  ";
            selectedSpecItems.push(entries[x]);
          }
        }
      }
      // 这做判断  skus  中  同时 包含  selectedSpecItems 的id  和 value的sku
      for (let i = 0; i < this.skus.length; i++) {
        let sku = this.skus[i];
        let isTrue = false;
        if (sku.specificationValues.length == selectedSpecItems.length) {
          for (let x = 0; x < sku.specificationValues.length; x++) {
            let specificationValue = sku.specificationValues[x];
            if (x == 0) {
              isTrue = true;
            }
            let selectedSpecItem = selectedSpecItems[x];
            if (specificationValue.id == selectedSpecItem.id && specificationValue.value ==
              selectedSpecItem.value) {
              isTrue = isTrue && true;
            } else {
              isTrue = isTrue && false;
            }
          }
          if (isTrue) {
            this.formData.skuId = sku.id;
            this.sku = sku;
            break;
          }
        }
      }
      //根据skuList  选定sku
      // 获取sku 库存,编号，价格，等信息
      //订单提交的时候sku，数量
      // 订单加入购物车的时候
      this.goods_marketing_goods();
    },
    onErrorImg(item) {
      this.$set(item, 'thumbnail', "/static/images/default_thumbnail.jpg");
      this.$set(item, 'logo', "/static/images/default_thumbnail.jpg");
    },
    //尺寸
    guanbi: function (e) {
      var that = this;
      var name = e.currentTarget.dataset.name;
      if (name == 'youhuishow') {
        that.youhuishow = false;
      }

      if (name == 'guigeshow') {
        that.guigeshow = false;
      }

      if (name == 'dizhishow') {
        that.dizhishow = false;
      }
    },
    showbox: function (e) {
      var that = this;
      var name = e.currentTarget.dataset.name;
      if (name == 'youhuishow') {
        that.youhuishow = true;
      }

      if (name == 'guigeshow') {
        that.guigeshow = true;
      }

      if (name == 'dizhishow') {
        that.dizhishow = true;
      }
    },
    cart_add_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.$message({
          message: '请选择规格',
        });
        // if (this.guigeshow) {
        // uni.showToast({
        // 	title: "请选择规格",
        // 	duration: 2000
        // });
        // }
        // this.guigeshow = true;
      } else {
        this.cart_add();
      }
    },
    cancel_handler: function (e) {
      this.guigeshow = false;
    },
    buy_handler: function (e) {
      this.notJoinGroup = false;
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        $message('请选择商品规格');
        // this.guigeshow = true;
      } else {

        this.$router.push({ name: "settlement", query: { skuId: this.formData.skuId, marketingId: this.marketingId, quantity: this.formData.quantity } });
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },

    buy_handler_nogroup: function (e) {
      this.notJoinGroup = true;
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&notJoinGroup=true&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },

    seckill_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&quantity=' + this
        // 		.formData.quantity
        // })

      }
    },
    group_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },
    exchange_handler: function (e) {
      if (!(this.formData.skuId && this.formData.skuId.length > 0)) {
        this.guigeshow = true;
      } else {
        //购买逻辑
        // uni.navigateTo({
        // 	url: '../../order/order/checkout?skuId=' + this.formData.skuId + "&marketingId=" + this
        // 		.marketingId + '&orderType=EXCHANGE&quantity=' + this
        // 		.formData.quantity
        // })
      }
    },
    cart_add: function (e) {
      this.loading = true
      // var uInfo = localStorage.getItem("userInfoStorage");
      // localStorage.setItem("aaa","bbb");
      // if (notLogin()) {
      //   return;
      // }
      if (this.isLogin) {
        //添加到购物车  
        this.loading=true;
        add(this.formData).then(response => {
          this.loading=false;
          this.loading = false;
          let currentCart = response.data.data.currentCart;
          if (currentCart) {

            this.cartQuantity = response.data.data.quantity;
            this.formData.currentCartId = currentCart.id;



            //       formData: {
            //   skuId: null,
            //   marketingId: null,
            //   quantity: 1,
            //   currentCartId: ''
            // },

            // const cartItems = this.$store.state.cartItems?this.$store.state.cartItems:[];
            // let quantity= this.formData.quantity;

            // let selectSkuName='';
            // if(this.sku.specifications&&0<this.sku.specifications.length){
            //   for(let i=0;i<this.sku.specifications.length;i++){
            //     selectSkuName+=this.sku.specifications[i]+' , ';
            //   }
            // }
            // cartItems.push({
            //   // ...this.productDetails,
            //   checked:true,
            //   name:this.obj.name,
            //   skuId: this.formData.skuId,
            //   checkAttrName:selectSkuName,
            //   zoomImg: this.sku.skuImage?this.sku.skuImage:this.obj.thumbnail,
            //   quantity:this.formData.quantity,
            //   price:Number(this.sku.price),
            //   Identifier: new Date().getTime(),
            // });

            // cartItems.push({
            //     checked: false
            //     goodsId: "1765375073915736066"
            //     price: 1879
            //     quantity: 1
            //     skuId: "1769320289274105858"
            //     skuName: "Huawei Pocket 2"
            //     skuThumbnail: "http://qiniuio.bizspring.cn//1/goods/00f742f2-b536-4f4f-9622-2f39cc614768_thumbnail.jpg/82737314-d992-4eeb-8eed-a2d43def5263.jpg"
            //     specifications: ["Gray", "512GB+12GB"]
            //     subtotal
            //     Identifier: new Date().getTime(),
            //  });


            // this.$store.commit("SETCARTITEMS", cartItems);

            //     this.$message({
            //       message: this.$t(
            //         "message.home.addCartMessage" /**添加到购物车成功 */
            //       ),
            //       type: "success",
            //     });
            this.$store.commit("SETCURRENTCART", currentCart);
            this.loadCartItems();
            // localStorage.setItem("currentCart", JSON.stringify(currentCart));
            // uni.setStorageSync("cartQuantity", this.cartQuantity);
            // this.youhuishow = false;
            // this.guigeshow = false;
            // this.dizhishow = false;
            // uni.showToast({
            // 	title: this.messages['shop_goods_addedCart'],
            // 	duration: 2000
            // });
          }
        }).catch(error => {
          this.loading=false;
          console.error("error", error);
          // uni.showToast({
          // 	title: this.messages['common_message_unknownError'],
          // 	duration: 2000
          // });
        })
      } else {
        setTimeout(function () {
          // uni.reLaunch({
          // 	url: '../../upms/login/sms'
          // });
        }, 100);
      }
    },

    bindMinus: function () {
      this.formData.quantity -= 1;
    },
    bindPlus: function () {
      this.formData.quantity += 1;
    },



    //////////////////////////////////////////////////////////////////////////////////////////////////






  },
};
</script>

<style lang="scss">
html[dir="rtl"] {
  .product-info-right-info-des-item div:first-child {
    margin-right: 0 !important;
  }

  .product-info-left {
    margin-right: 0 !important;
    margin-left: 22px !important;
  }

  .product-details-merchant,
  .titleRe {
    margin-right: 17px;
    margin-left: 0;
  }

  .product-details-merchant-top h1 {
    margin-right: 10px;
    margin-left: 0;
  }

  .product-info-right-info-price h2 {
    padding-right: 0;
    padding-left: 8px;
  }

  .product-info-right-info-tool-item {
    margin-right: 0;
    margin-left: 30px;

    span {
      margin-right: 6px;
      margin-left: 0;
    }
  }

  .product-info-right-info-des {
    .label-title {
      margin-right: 0;
    }

    .el-select {
      width: 200px;
    }

    .product-attr {
      align-items: flex-start !important;
    }
  }

  .sku-titile {
    display: inline-block;
    text-align: right;
    width: 100%;
  }

}

.product-info {
  margin-top: 3px;

  &-content {
    align-items: flex-start;
  }

  &-left {
    width: 378px;
    margin-right: 22px;

    .gallery-top {
      width: 378px;
      height: 378px;
      border: 1px solid var(--color-border);
      border-radius: 4px;

      .swiper-slide {
        width: 378px;
        height: 378px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 10px;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
    }

    .selector {
      z-index: 2 !important;
    }

    .out-zoomer {
      z-index: 8 !important;
      background: #fff;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .gallery-thumbs {
      height: 89px;
      margin-top: 15px;

      .swiper-slide {
        width: 87px;
        height: 89px;
        border: 1px solid var(--color-border);
        box-sizing: border-box;
        border-radius: 4px;
        padding: 5px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          max-width: 87px;
          object-fit: cover;
        }
      }

      .active {
        border: 1px solid var(--color-main);
      }

      .slide-thumb-active {
        border-color: var(--color-main) !important;
        border-width: 2px !important;
      }

      // .swiper-slide-active {
      //   // opacity: 1;
      // }
    }
  }

  &-right {
    max-width: 563px;

    &-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      color: var(--color-black);
      margin-bottom: 14px;
      word-break: break-all;
    }

    &-info {
      &-top {
        width: 100%;
        padding: 18px 0;
        border-top: 1px solid var(--color-border);
        border-bottom: 1px solid var(--color-border);
      }

      &-price {
        h2 {
          min-width: 10px;
          text-align: left;
          font-weight: 400;
          font-size: 12px;
          color: var(--color-subtitle);
          padding-right: 8px;
        }

        &.del {
          text-decoration: line-through;

          h2 {
            width: auto;
            min-width: 10px;
            padding-right: 2px;
          }

          .price {
            font-size: 14px;
            color: var(--color-price);
          }
        }
      }

      &-tool {
        &-item {
          cursor: pointer;
          margin-right: 30px;

          &:last-child {
            margin-right: 0;
          }

          span {
            color: var(--color-title);
            margin-left: 6px;
          }

          .el-icon-star-off {
            font-size: 18px;
            color: var(--color-main);
          }

          .el-icon-star-on {
            font-size: 18px;
            color: var(--color-main);
          }
        }
      }

      &-des {
        font-weight: 400;
        font-size: 12px;
        color: var(--color-subtitle);

        &-item {
          margin-top: 25px;

          // div:first-child {
          //   margin-right: 20px;
          // }
        }

        .del-line {
          text-decoration: line-through;
          margin-left: 27px;
        }

        .label-title {
          display: inline-block;
          min-width: 67px;
          margin-right: 16px;
        }

        .product-attr {
          flex-direction: column;
          align-items: baseline !important;

          .label-title {
            margin-bottom: 10px;
          }
        }

        .attr-container {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(54px, 54px));
          grid-column-gap: 10px;
          grid-row-gap: 5px;
          align-content: center;
          padding-bottom: 4px;
        }

        .active {
          border: 1px solid var(--color-main);

          border-radius: 4px;

          .attr-img {
            border: none !important;
          }
        }

        .disabled {
          opacity: 0.5;
          // cursor: not-allowed;
          border: 1px dashed #e6e6e6;
          cursor: no-drop !important;

          .attr-img {
            border: none !important;
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
            filter: gray;
          }
        }

        .attr-item {
          // width: 100%;
          // display: flex;
          // flex-wrap: wrap;
          margin-right: 0 !important;
          cursor: pointer;

          .attr-img {
            // width: 54px;
            height: 54px;
            padding: 5px;
            border-radius: 4px;
            border: 1px solid var(--color-border);

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }

      &-buy {
        width: 100%;
        text-align: center;
        margin-top: 72px;
        margin-bottom: 40px;
        display: flex;
        justify-content: space-between;

        .el-button {
          width: 45%;
          max-width: 570px;
          height: 44px;
          font-weight: 700;
          font-size: 14px;
          padding: 0;
        }

        .addcart {
          width: 45%;
          max-width: 570px;
          height: 44px;
          font-weight: 700;
          font-size: 14px;
          padding: 0;
          justify-content: center;
          color: var(--color-main);
          background: linear-gradient(0deg, #fff7ec, #fff7ec), #eeeeee;
          border: 1px solid var(--color-main);
          border-radius: 4px;
          cursor: pointer;
          will-change: filter;
          transition: filter 500ms;

          &:hover {
            filter: drop-shadow(0 0 4px var(--color-main));
            // color: var();
          }
        }
      }

      .price {
        font-weight: 500;
        font-size: 16px;
        color: var(--color-price);
      }
    }
  }
}

.freight-tips {
  display: flex;
  align-items: center;

  i {
    margin-left: 10px;
    cursor: pointer;
    font-size: 16px;

    &:hover {
      color: #000;
    }
  }
}

.disBtn {
  opacity: .5;
  cursor: no-drop !important;
}
</style>
